import React from 'react';
import {Button, ConfigProvider, Pagination, Row, Table, Tooltip} from "antd";
import {connect} from "react-redux";
import {SearchOutlined} from "@ant-design/icons";
import language from "../../languages/language";
import getWorkflowFilesInformation from "../../actions/getWorkflowFilesInformation";
import isLoggedIn from "../../actions/isLoggedIn";
import './Docs.css';
import esCO from "antd/es/locale/es_ES";
import {CONFIRM_MODAL, /* WORKFLOW_MODAL */} from "../../types";
import modalShow from "../../actions/modalShow";


class WorkflowDocs extends React.Component {

    state={pending:true,skip:1,limit:10};
    componentDidMount()
    {
        this.props.isLoggedIn();
        this.getWorkflowFilesInformation();
    }

    openTrack=(record)=>
    {
        this.props.modalShow({
            modalType: CONFIRM_MODAL,
            modalProps: {footer: null, title: language[this.props.language].advTrackLabel},
            componentProps: {uid:record.uid}});
    };

     columns() {
        let columns=[];
         columns.push({title: language[this.props.language].advFileNameLabel,dataIndex: 'fileName',className: 'mobile-show'});
         columns.push({title: language[this.props.language].advCreationDateLabel,dataIndex: 'creationDate',className: 'mobile-show'});
         columns.push({
             title: language[this.props.language].advActionsLabel,
             key: 'action',
             render: (text, record) => (
                 <span className={'pending-action-buttons'}>
                     <Tooltip title={language[this.props.language].advTrackLabel}>
                            <Button style={{marginBottom:0}} icon={<SearchOutlined />}
                                    type={'danger delete-btn'} htmlType={'button'}
                                    onClick={() => this.openTrack(record)}/>
                     </Tooltip>
                 </span>
             ),
             className: 'mobile-show'
         });
          return columns;
      }

      getWorkflowFilesInformation=()=>
      {
          this.props.getWorkflowFilesInformation({...this.state});
      };

      handlePageChange = (page) =>
      {
          this.setState({skip: page}, this.getWorkflowFilesInformation);
      };

      render() {
          return (
            <div style={{margin: '20px'}} className={'signed-docs card-container'}>
              <h3>{language[this.props.language].advWorkflowInfo}</h3>
                  <div style={{backgroundColor: '#FFFFFF'}}>
                      <ConfigProvider locale={esCO}>
                    <Table style={{width:'100%'}}
                        columns={this.columns()}
                        dataSource={this.props.workflowList.filesInfo}
                        size={'small'}
                        rowKey={'uid'}
                        pagination={false}
                    />
                      </ConfigProvider>
                      <Row style={{justifyContent:'flex-end'}}>
                          <Pagination size="small" pageSize={this.state.limit} current={this.state.skip} showSizeChanger={false}
                              onChange={this.handlePageChange} total={this.props.workflowList.total}
                              showTotal={(total) => language[this.props.language].advTotalElements.replace('$0', total)}/>

                      </Row>
                  </div>
            </div>
        );
      }
}

const mapStateToProps = state => {
  return {
    workflowList: state.info.workflowList,
    language: state.auth.language
  };
};

export default connect(mapStateToProps, {getWorkflowFilesInformation,isLoggedIn,modalShow})(WorkflowDocs);
